import WhyPartnerWithUs from "@components/severalbrands/whyPartnerWithUs";
import UnlockBusiness from "./unlockBusiness";
import { MainImgTextSharedComponentElType } from "@components/severalbrands/ourStoryPage/mainSharedComponent";
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with businesses that need your solutions, navigating the complexities of the B2B market with confidence.",
            className: "default",
        },
        {
            text: "Let us help you unlock your company's full potential and thrive in this competitive industry. Together, we can transform your marketing strategy into a powerful tool for success, ensuring that your B2B solutions reach the businesses that need them most.",
            className: "default",
        },
    ],
    buttonText: "Partner With Us",
};
export default function GeneralCategoryForthSection({
    mainData,
}: {
    mainData?: {
        partnerWithUSData?: {
            title: string;
            paragraphs: { text: string; className: string | "default" }[];
            buttonText: string;
        };
        unlockBusinessContent?: MainImgTextSharedComponentElType[];
    };
}) {
    return (
        <section>
            <UnlockBusiness generalList={mainData?.unlockBusinessContent} />
            <div className="mt-32 lg:mt-56 lg:mb-48 mb-20">
                <WhyPartnerWithUs
                    partnerWitUSData={
                        mainData?.partnerWithUSData
                            ? mainData?.partnerWithUSData
                            : partnerWitUSData
                    }
                />
            </div>
        </section>
    );
}
